document.addEventListener("DOMContentLoaded", function () {
  const allProductsButton = document.querySelector(".header__button--all");
  const sidebar = document.querySelector(".products-sidebar");
  const columns = document.querySelectorAll(".products-sidebar__column");
  const closeButtons = document.querySelectorAll(".products-sidebar__close");
  const subitems = document.querySelectorAll(".products-sidebar__subitem");
  const backButtons = document.querySelectorAll(".products-sidebar__back");
  var initialZIndex = 2;
  allProductsButton.addEventListener("click", function () {
    document.body.classList.add("products-sidebar-open");
  });

  sidebar.addEventListener("click", function (e) {
    if (!e.target.closest(".products-sidebar__column")) {
      closeSidebar();
    }
  });

  closeButtons.forEach((closeButton) => {
    closeButton.addEventListener("click", function () {
      closeSidebar();
    });
  });

  subitems.forEach((subitem) => {
    const subcategory = subitem.dataset.subcategory;
    subitem.addEventListener("click", function () {
      const column = document.querySelector(
        `.products-sidebar__column[data-category="${subcategory}"]`
      );
      console.log(subcategory);
      column.classList.add("products-sidebar__column--active");
      column.style.zIndex = initialZIndex + 1;
      initialZIndex++;
    });
  });

  backButtons.forEach((backButton) => {
    backButton.addEventListener("click", function () {
      const column = backButton.closest(".products-sidebar__column");
      column.classList.remove("products-sidebar__column--active");
    });
  });

  function closeSidebar() {
    document.body.classList.remove("products-sidebar-open");
    columns.forEach((column) => {
      column.classList.remove("products-sidebar__column--active");
      column.style.zIndex = 0;
      initialZIndex = 0;
    });
  }
});
